import React from "react";
import cx from "classnames";
import { dataTestIds } from "data-testids";
import "./Pill.scss";

export interface IPillProps {
  /** Title for component */
  title?: string;
  /** Icon for component */
  icon?: string | React.ReactNode;
  /** Theme for component */
  theme?: "dark" | "light";
  /** Size of component */
  size?: "lg" | "md";
  className?: string;
  variant?: "link-to-profile";
}

export const Pill: React.FC<React.PropsWithChildren<IPillProps>> = ({
  title,
  icon,
  children,
  theme,
  size = "lg",
  variant,
  className,
}) => {
  const rootClassNames = cx(
    "pill",
    `pill--${theme}`,
    `pill--${size}`,
    className,
    {
      "pill--link-to-profile": variant === "link-to-profile",
    }
  );

  return (
    <span className={rootClassNames} title={title}>
      {icon && (
        <span className="pill__icon-container">
          {typeof icon === "string" ? (
            <img src={icon} alt={`${title} icon`} className="pill__icon-img" />
          ) : (
            icon
          )}
        </span>
      )}
      <h5
        className="pill__children-container"
        data-testid={dataTestIds.componentLibrary["Atoms.Pill.icon"]}
      >
        {children}
      </h5>
    </span>
  );
};
